import { render, staticRenderFns } from "./BaseBreadCrumb.vue?vue&type=template&id=ee9b497e&"
import script from "./BaseBreadCrumb.vue?vue&type=script&lang=js&"
export * from "./BaseBreadCrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports